export abstract class Store<State, Listener extends () => void = () => void> {
  protected state: State
  private listeners = new Set<Listener>()

  protected constructor(initialState: State) {
    this.state = initialState
  }

  protected isServer(): boolean {
    return typeof window === 'undefined'
  }

  protected setState(next: State) {
    if (Object.is(this.state, next)) {
      return
    }
    this.state = next
    this.listeners.forEach((listener) => listener())
  }

  protected onFirstSubscribe() {}
  protected onLastUnsubscribe() {}

  subscribe = (listener: Listener) => {
    this.listeners.add(listener)

    if (this.listeners.size === 1) {
      this.onFirstSubscribe()
    }

    return () => {
      this.listeners.delete(listener)

      if (this.listeners.size === 0) {
        this.onLastUnsubscribe()
      }
    }
  }

  abstract getSnapshot(): State
  abstract getServerSnapshot(): State
}
